import jwt from "jsonwebtoken";
import moment from 'moment';
import Swal from "sweetalert2";

export const PAGE_SIZE = 25;

// Always builds limit/offset (+ optional search/extra params) so callers never fall back
// to an unpaginated bare-URL request on page 1.
export const buildListUrl = (baseUrl, { pageNumber = 1, limit = PAGE_SIZE, search, extra = {} } = {}) => {
  const offset = limit * (pageNumber - 1);
  const params = new URLSearchParams({ limit, offset, ...extra });
  if (search) {
    params.set("search", search);
  }
  return `${baseUrl}?${params.toString()}`;
};

export const thai_date = (date_data, time_type = "date") => {
  let today = new Date(date_data);
  var months = ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค.",];
  var weekday = ["อาทิตย์", "จันทร์", "อังคาร", "พุธ", "พฤหัสบดี", "ศุกร์", "เสาร์"];
  var shortweekday = ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."];

  let week_day = today.getDay();
  if (time_type === "date") {
    const today_text = "วัน" + weekday[week_day] + "ที่ " + (today.getDay()) + " " + (months[today.getMonth()]) + (today.getYear() + 43) % 100;
    return today_text;
  }
  else if (time_type === "shortdate") {
    const today_text = shortweekday[week_day] + " " + (today.getDate()) + " " + (months[today.getMonth()]) + (today.getFullYear() + 543);
    return today_text;
  }
  else if (time_type === "weekday") {
    const today_text = shortweekday[week_day];
    return today_text;
  }
  else if (time_type === "year") {
    const today_text = today.getFullYear() + 543
    return today_text;
  }
  else if (time_type === "month") {
    const month_text = (months[today.getMonth()]) + " " + (today.getFullYear() + 543);
    return month_text;
  }

  return "";
};

export const thai_date_picker = (date) => {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // เดือนเริ่มจาก 0
  const year = date.getFullYear() + 543;
  return `${day}-${month}-${year}`; // คืนค่าในรูปแบบ dd-MM-yyyy
};

export const maskIDNumber = (idNumber) => {
  const maskedID = idNumber.substring(0, 4) + 'xxxxx' + idNumber.substring(9);

  const formatNo = `${maskedID[0]}-${maskedID.slice(1, 5)}-${maskedID.slice(5, 10)}-${maskedID[10]}-${maskedID.slice(11, 13)}`;
  return formatNo;
};

export const handleResizeDisplay = (setIsStacked) => {
  const windowWidthRef = { current: document.documentElement.clientWidth };

  const resizeHandler = () => {
    windowWidthRef.current = document.documentElement.clientWidth;

    if (windowWidthRef.current <= 992) {
      setIsStacked(true);
    } else {
      setIsStacked(false);
    }
  };

  window.addEventListener("resize", resizeHandler);
  resizeHandler();

  return () => {
    window.removeEventListener("resize", resizeHandler);
  };
};
export const formatdate = (date) => {
  return moment(date).format('YYYY-MM-DD');
};
export const getlocalStorage = () => {
  const Token = localStorage.getItem("Token"); //api
  const Token_ = localStorage.getItem("Token_");//me
  const DataToken_jwt = jwt.verify(Token_, process.env.REACT_APP_JWT);
  const DataToken_ = JSON.parse(JSON.stringify(DataToken_jwt));
  return { Token, Token_, DataToken_ };
};

export const checkGroupsUser = (accessRights) => {


  const map_ = {
    "FunctionaryTester": {
      display_name: "เจ้าหน้าที่ทดสอบ", level: 3,
      openRole: {
        UnitAdmin: false,
        RTAFPersonAdmin: false,
        FunctionaryTester: true,
      },
    },
    "RTAFPersonAdmin": {
      display_name: "เจ้าหน้าที่กำลังพล ทอ.", level: 1,
      openRole: {
        UnitAdmin: false,
        RTAFPersonAdmin: true,
        FunctionaryTester: false,
      },
    },
    "UnitAdmin": {
      display_name: "เจ้าหน้าที่กำลังพลของหน่วย", level: 2,
      openRole: {
        UnitAdmin: true,
        RTAFPersonAdmin: false,
        FunctionaryTester: false,
      },
    },
  }

  function compareAccessRights(accessRights, map_) {
    const results = [];
    let res = [];
    const data_1 = accessRights.map(role => ({ name: role }));
    const data_2 = accessRights.map(role => role);

    const isAccessRights = (rights) => {
      if (!Array.isArray(rights)) {
        return false;
      }
      return rights.every(right =>
        typeof right === 'object' &&
        right !== null &&
        'name' in right &&
        typeof right.name === 'string'
      );
    };

    const transformedAccessRights = isAccessRights(accessRights) ? data_2 : data_1;

    for (let access of transformedAccessRights) {
      const roleName = access.name;
      if (map_.hasOwnProperty(roleName)) {
        results.push({
          role_name: map_[roleName].display_name,
          level: map_[roleName].level,
          openRole: map_[roleName].openRole
        });
      }
    }

    res = accessRights.length > 0 ? results : [{
      role_name: "ผู้ใช้ทั่วไป", level: 4,
      openRole: {
        UnitAdmin: false,
        RTAFPersonAdmin: false,
        FunctionaryTester: false,
      },
    }];
    const role = res.sort((a, b) => a.level - b.level);

    return role[0]
  }

  const role = compareAccessRights(accessRights, map_);

  return role;
}
export const getReasonText = (reason) => {
  switch (reason) {
    case 0:
      return "";
    case 1:
      return "ราชการ";
    case 2:
      return "ศึกษา";
    case 3:
      return "ป่วย";
    case 4:
      return "อื่นๆ";
    default:
      return "";
  }
};

export const showLoading = (title = 'กำลัง Update ข้อมูล...') => {
  Swal.fire({
    title,
    allowOutsideClick: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });
};

export const hideLoading = () => {
  Swal.close();
};
// รองรับกรณีที่ API ส่งค่ามาเป็นตัวเลข (เช่น -1 = ยังไม่ได้ทดสอบ) หรือ null
// แทนที่จะเป็น string รูปแบบ "mm:ss" เสมอ -> คืนค่า NaN เพื่อให้การเปรียบเทียบเป็น false
export const convertTimeStringToSeconds = (timeString) => {
  if (timeString === null || timeString === undefined) return NaN;

  const raw = String(timeString).trim();
  if (raw === "") return NaN;

  // ผู้ใช้กรอกได้ทั้ง "mm:ss" และ "mm.ss" (ดู isValidTimeFormat)
  const [minutePart, secondPart = "0"] = raw.split(/[:.]/);
  const minutes = parseInt(minutePart, 10);
  const second = parseInt(secondPart, 10);

  // ค่าติดลบคือค่า sentinel ของ "ยังไม่ได้ทดสอบ" (-1, "-1:59")
  if (Number.isNaN(minutes) || Number.isNaN(second) || minutes < 0) return NaN;

  return minutes * 60 + second;
};

export const isValidTimeFormat = (timeString) => {
  const delimiter = timeString[2]; // ตัวแบ่งระหว่างชั่วโมงและนาที
  if (delimiter !== ":" && delimiter !== ".") return false;

  const [hours, minutes] = timeString.split(delimiter);
  const hoursNum = Number(hours);
  const minutesNum = Number(minutes);

  return (
    timeString.length === 5 &&
    hoursNum >= 0 &&
    hoursNum <= 99 &&
    minutesNum >= 0 &&
    minutesNum <= 59
  );
};

export const adjustTableWidths = () => {
  window.addEventListener("load", function () {
    var table = document.querySelector("table");
    var ths = table?.querySelectorAll("th");
    var col1 = table.querySelectorAll("td:first-child, th:first-child");
    var col2 = table.querySelectorAll("td:nth-child(2), th:nth-child(2)");

    function setWidths() {
      if (ths && col1.length && col2.length) {
        ths[0].style.width = col1[0].offsetWidth + "px";
        ths[1].style.width = col2[0].offsetWidth + "px";
      }
    }

    setWidths();
    window.addEventListener("resize", setWidths);
  });
};

export const scrollToElement = (ref) => {
  if (ref.current) {
    ref.current.scrollIntoView({ behavior: 'smooth' });
  }
};


export const calculateSumsByAirWorker = (data) => {
  const result = {
    "ผู้ทำการในอากาศ": {
      totalNumTest3Stations: 0,
      totalNumPass: 0,
      percentagePass: 0,
      
    },
    "ผู้ทำการภาคพื้น": {
      totalNumTest3Stations: 0,
      totalNumPass: 0,
      percentagePass: 0,
    }
  };

  data.forEach(item => {
    const { air_worker, num_test_3_stations = 0, num_pass_210 = 0, num_pass_150 = 0 } = item;


    if (air_worker === "ผู้ทำการในอากาศ") {
      result["ผู้ทำการในอากาศ"].totalNumTest3Stations += num_test_3_stations;
      result["ผู้ทำการในอากาศ"].totalNumPass += num_pass_210;
    } else if (air_worker === "ผู้ทำการภาคพื้น") {
      result["ผู้ทำการภาคพื้น"].totalNumTest3Stations += num_test_3_stations;
      result["ผู้ทำการภาคพื้น"].totalNumPass += num_pass_150;
    }
  });


  Object.keys(result).forEach(air_worker => {
    const totalNumTest3Stations = result[air_worker].totalNumTest3Stations;
    const totalNumPass = result[air_worker].totalNumPass;
    result[air_worker].percentagePass = totalNumTest3Stations > 0 ? (totalNumPass / totalNumTest3Stations) * 100 : 0;
  });

  return result;
};

export const sumNumTest3Stations = (data) => {
  const groupedData = {};

  data.forEach(item => {
    const { unit, air_worker } = item;


    if (!groupedData[unit]) {
      groupedData[unit] = {};
    }


    if (!groupedData[unit][air_worker]) {
      groupedData[unit][air_worker] = {
        totalNumTest3Stations: 0,
        totalNumPass: 0,
        percentage_total: 0
      };
    }


    groupedData[unit][air_worker].totalNumTest3Stations += item.num_test_3_stations || 0;


    if (air_worker === "ผู้ทำการในอากาศ") {
      groupedData[unit][air_worker].totalNumPass += item.num_pass_210 || 0;
    } else if (air_worker === "ผู้ทำการภาคพื้น") {
      groupedData[unit][air_worker].totalNumPass += item.num_pass_150 || 0;
    }

  });

  Object.keys(groupedData).forEach(unit => {
    Object.keys(groupedData[unit]).forEach(air_worker => {
      const totalNumTest3Stations = groupedData[unit][air_worker].totalNumTest3Stations;
      const totalNumPass = groupedData[unit][air_worker].totalNumPass;


      if (totalNumTest3Stations > 0) {
        groupedData[unit][air_worker].percentage_total = (totalNumPass / totalNumTest3Stations) * 100;
      } else {
        groupedData[unit][air_worker].percentage_total = 0;
      }
    });
  });
  return groupedData;



}
export const calculateSumsByUnit = (allData) => {
  return allData.reduce((acc, item) => {
    const unit = item.unit;


    if (!acc[unit]) {
      acc[unit] = {
        num_absent_with_reason: 0,
        num_absent_noreason: 0,
        num_pass_150: 0,
        num_all: 0,
        num_no_pass: 0,
        num_pass_all_score: 0,

        num_test_1_2_stations: 0,
        num_test_3_stations: 0
      };
    }


    acc[unit].num_absent_with_reason += item.num_absent_with_reason;
    acc[unit].num_absent_noreason += item.num_absent_noreason;
    acc[unit].num_pass_150 += item.num_pass_150;
    acc[unit].num_all += item.num_all;
    acc[unit].num_test_1_2_stations += item.num_test_1_2_stations;
    acc[unit].num_test_3_stations += item.num_test_3_stations;

    if (item.air_worker === "ผู้ทำการในอากาศ") {
      acc[unit].num_pass_all_score += item.num_pass_210 || 0;
    } else if (item.air_worker === "ผู้ทำการภาคพื้น") {
      acc[unit].num_pass_all_score += item.num_pass_150 || 0;
    }


    acc[unit].num_no_pass =
      acc[unit].num_all -
      (acc[unit].num_absent_with_reason +
        acc[unit].num_pass_all_score +
        acc[unit].num_absent_noreason);
    return acc;
  }, {});



}

export const getSummaryData = (groupedData) => {
  return Object.keys(groupedData).map((unit) => {


    const num_not_tested = groupedData[unit].num_absent_with_reason;
    const num_tested = groupedData[unit].num_pass_all_score + groupedData[unit].num_no_pass;
    const num_all_send_report = groupedData[unit].num_pass_all_score + groupedData[unit].num_no_pass + groupedData[unit].num_absent_with_reason;
    const num_pass = groupedData[unit].num_pass_all_score;
    const num_no_pass = groupedData[unit].num_no_pass;
    const num_test_1_2_stations = groupedData[unit].num_test_1_2_stations;
    const num_test_3_stations = groupedData[unit].num_test_3_stations;
    const num_pass_all_score = groupedData[unit].num_pass_all_score

    const percentage_not_tested = num_all_send_report > 0 ? (num_not_tested / num_all_send_report) * 100 : 0;
    const percentage_num_pass = num_all_send_report > 0 ? (num_pass / num_all_send_report) * 100 : 0;
    const percentage_num_no_pass = num_all_send_report > 0 ? (num_no_pass / num_all_send_report) * 100 : 0;

    const percentagenum_pass_test_3_stations = num_all_send_report > 0 ? (num_pass_all_score / num_all_send_report) * 100 : 0;
    return {
      unit: unit,
      num_not_tested: num_not_tested,
      num_tested: num_tested,
      num_pass: groupedData[unit].num_pass_all_score,
      num_no_pass: groupedData[unit].num_no_pass,
      num_all_send_report: num_all_send_report,
      percentage_not_tested: percentage_not_tested,
      percentage_num_pass: percentage_num_pass,
      percentage_num_no_pass: percentage_num_no_pass,
      num_test_3_stations: num_test_3_stations,
      num_test_1_2_stations: num_test_1_2_stations,
      num_pass_all_score: num_pass_all_score,
      percentagenum_pass_test_3_stations: percentagenum_pass_test_3_stations
    };
  });


}

export const getOverallSummary = (groupedData) => {
  const totals = {
    num_not_tested: 0,
    num_tested: 0,
    num_all_send_report: 0,
    percentage_not_tested: 0,
    percentage_tested: 0,
    num_unit: 0,

    
    num_no_pass: 0,
    num_pass_all_score: 0,
    percentage_num_pass: 0,
    percentage_num_no_pass: 0,

  };


  Object.values(groupedData).forEach((data) => {
    totals.num_not_tested += data.num_absent_with_reason;
    totals.num_tested += data.num_pass_all_score + data.num_no_pass;
    totals.num_all_send_report += data.num_pass_all_score + data.num_no_pass + data.num_absent_with_reason;
    totals.num_no_pass += data.num_no_pass
    totals.num_pass_all_score += data.num_pass_all_score



  });




  if (totals.num_all_send_report > 0) {
    totals.percentage_not_tested = (totals.num_not_tested / totals.num_all_send_report) * 100;
    totals.percentage_tested = (totals.num_tested / totals.num_all_send_report) * 100;
    totals.percentage_num_pass = (totals.num_pass_all_score / totals.num_all_send_report) * 100;
    totals.percentage_num_no_pass = (totals.num_no_pass / totals.num_all_send_report) * 100;

  }
  totals.num_unit = Object.keys(groupedData).length;
  return totals;


}


export const combineDuplicateUnits = (allData) => {
  const combinedData = {};

  allData.forEach((item) => {
    const unit = item.unit;
    const airWorkerType = item.air_worker; // ประเภท air_worker ('ผู้ทำการภาคพื้น' หรือ 'ผู้ทำการในอากาศ')

    // ตรวจสอบว่ามี unit นี้ใน combinedData หรือยัง
    if (!combinedData[unit]) {
      combinedData[unit] = {
        unit,
        air_worker: {
          'ผู้ทำการภาคพื้น': {
            num_absent_noreason: 0,
            num_absent_with_reason: 0,
            num_all: 0,
            num_pass_150: 0,
            num_pass_210: 0,
            num_test_1_2_stations: 0,
            num_test_3_stations: 0,
            count: 0,
            value: 0,
          },
          'ผู้ทำการในอากาศ': {
            num_absent_noreason: 0,
            num_absent_with_reason: 0,
            num_all: 0,
            num_pass_150: 0,
            num_pass_210: 0,
            num_test_1_2_stations: 0,
            num_test_3_stations: 0,
            count: 0,
            value: 0,
          },
        },
      };
    }

    // ตรวจสอบว่า air_worker ตรงกับประเภทที่มีอยู่และรวมค่าลงไป
    if (combinedData[unit].air_worker[airWorkerType]) {
      const targetWorker = combinedData[unit].air_worker[airWorkerType];

      // รวมค่าจาก item ลงไปยัง targetWorker
      targetWorker.num_absent_noreason += item.num_absent_noreason || 0;
      targetWorker.num_absent_with_reason += item.num_absent_with_reason || 0;
      targetWorker.num_all += item.num_all || 0;
      targetWorker.num_pass_150 += item.num_pass_150 || 0;
      targetWorker.num_pass_210 += item.num_pass_210 || 0;
      targetWorker.num_test_1_2_stations += item.num_test_1_2_stations || 0;
      targetWorker.num_test_3_stations += item.num_test_3_stations || 0;
      targetWorker.count += item.count !== undefined ? parseInt(item.count, 10) : 0;
      targetWorker.value += item.value !== undefined ? parseFloat(item.value) : 0;
    }

    // ตรวจสอบว่ามี air_worker ประเภทนี้ใน item หรือไม่
    if (!combinedData[unit].air_worker[airWorkerType]) {
      combinedData[unit].air_worker[airWorkerType] = {
        num_absent_noreason: 0,
        num_absent_with_reason: 0,
        num_all: 0,
        num_pass_150: 0,
        num_pass_210: 0,
        num_test_1_2_stations: 0,
        num_test_3_stations: 0,
        count: 0,
        value: 0,
      };
    }
  });

  // แปลงข้อมูลที่รวมแล้วกลับเป็น array
  return Object.values(combinedData);
};

export const prepareSeriesForChart = (Heatmap) => {
  const categories = Object.keys(Heatmap.pushup);

  return Object.keys(Heatmap).map(exercise => {
      const series = categories.map(category => ({
          category: category,
          score: Heatmap[exercise][category] || 0,
          target: Heatmap[exercise][category] || 0
      }));


      const combinedCategory = series.find(s => s.category === "90-99");
      const combinedCategory2 = series.find(s => s.category === "100-109");

      if (combinedCategory && combinedCategory2) {
          const combinedScore = combinedCategory.score + combinedCategory2.score;
          const combinedTarget = combinedCategory.target + combinedCategory2.target;

          series.push({
              category: "90-100",
              score: combinedScore,
              target: combinedTarget
          });


          series.splice(series.indexOf(combinedCategory), 1);
          series.splice(series.indexOf(combinedCategory2), 1);
      }


      const otherCategory = series.find(s => s.category === "Other");
      if (otherCategory) {
          series.splice(series.indexOf(otherCategory), 1);
          series.push(otherCategory);
      }

      return {
          station: exercise,
          series: series,
      };
  });
};

export const calculateSummaryAndPercentages = (Heatmap) => {
  let totalWalkScore = 0;
  let totalWalkTarget = 0;
  let totalRunScore = 0;
  let totalRunTarget = 0;


  Heatmap.forEach(station => {
      if (station.station === 'walk') {
          totalWalkScore = station.series.reduce((total, item) => total + item.score, 0);
          totalWalkTarget = station.series.reduce((total, item) => total + item.target, 0);
      } else if (station.station === 'run') {
          totalRunScore = station.series.reduce((total, item) => total + item.score, 0);
          totalRunTarget = station.series.reduce((total, item) => total + item.target, 0);
      }
  });


  const combinedScore = totalWalkScore + totalRunScore;
  const combinedTarget = totalWalkTarget + totalRunTarget;


  Heatmap.forEach(station => {
      const totalScore = station.series.reduce((total, item) => total + item.score, 0);


      station.series = station.series.map(item => ({
          ...item,
          percentage: totalScore > 0 ? ((item.score / totalScore) * 100).toFixed(1) : 0
      }));


      if (station.station === 'walk' || station.station === 'run') {
          station.series.forEach(item => {
              item.percentage = combinedTarget > 0 ? ((item.score / combinedTarget) * 100).toFixed(1) : 0;
          });
      }
  });

  return Heatmap;
};

export const getFontSize = () => {
  const width = window.innerWidth;
        if (width < 600) {
            return '6px';
        } else if (width < 1000) {
            return '10px';
        } else {
            return '10px';
        }
};

// export const checkGroupsUser = async (AccessRights) => {


//   const access_role = Array.isArray(AccessRights) ? AccessRights.map((group) => {
//     if (group === "FunctionaryTester") {
//       return "เจ้าหน้าที่ทดสอบ";
//     } else if (group === "RTAFPersonAdmin") {
//       return "เจ้าหน้าที่กำลังพล ทอ.";
//     } else if (group === "UnitAdmin") {
//       return "เจ้าหน้าที่กำลังพลของหน่วย";
//     }
//     return "ผู้ใช้ทั่วไป";
//   }) : [];

//   // ตรวจสอบการมีอยู่ของบทบาทที่เฉพาะเจาะจง
//   const checkElement = (array, str) => {
//     return array.includes(str);
//   };

//   const chk_UnitAdmin = checkElement(access_role, 'เจ้าหน้าที่กำลังพลของหน่วย');
//   const chk_FunctionaryTester = checkElement(access_role, 'เจ้าหน้าที่ทดสอบ');
//   const chk_RTAFPersonAdmin = checkElement(access_role, 'เจ้าหน้าที่กำลังพล ทอ.');

//   return {
//     roles: {
//       chk_UnitAdmin,
//       chk_FunctionaryTester,
//       chk_RTAFPersonAdmin,
//     },
//   };

//   // try {
//   //   const response = await Axios.get(`${process.env.REACT_APP_API_USERS}${id}/`, {
//   //     headers: {
//   //       Authorization: "Token " + token,
//   //     },
//   //   });
//   //   if (response.status === 200){
//   //     const data = await response.data;
//   //     console.log("API Response:", data);

//   //     const access_role = data.groups?.map((group) => {
//   //       // console.log("Group Name:", group.name);
//   //       if (group.name === "FunctionaryTester") {
//   //         return "เจ้าหน้าที่ทดสอบ";
//   //       } else if (group.name === "RTAFPersonAdmin") {
//   //         return "เจ้าหน้าที่กำลังพล ทอ.";
//   //       } else if (group.name === "UnitAdmin") {
//   //         return "เจ้าหน้าที่กำลังพลของหน่วย";
//   //       }
//   //       else {
//   //         return "ผู้ใช้ทั่วไป";
//   //       }
//   //     }) || [];
//   //     // console.log("Access Roles:", access_role);
//   //     const checkElement = (array, str) => {
//   //       for (let i = 0; i < array.length; i++) {
//   //         if (array[i] === str || (Array.isArray(array[i]) && checkElement(array[i], str))) {
//   //           return true;
//   //         }
//   //       }
//   //       return false;
//   //     };

//   //     const chk_UnitAdmin = checkElement(access_role, 'เจ้าหน้าที่กำลังพลของหน่วย');
//   //     const chk_FunctionaryTester = checkElement(access_role, 'เจ้าหน้าที่ทดสอบ');
//   //     const chk_RTAFPersonAdmin = checkElement(access_role, 'เจ้าหน้าที่กำลังพล ทอ.');


//   //     return {
//   //       // data,
//   //       roles: {
//   //         chk_UnitAdmin,
//   //         chk_FunctionaryTester,
//   //         chk_RTAFPersonAdmin,
//   //       },
//   //       // roleUser
//   //     };
//   //   }

//   // } catch (err) {
//   //   if (err.response?.status === 401) {
//   //     localStorage.removeItem("Token_");
//   //     throw new Error('Unauthorized');
//   //   }
//   //   throw err;
//   // }
// };



